import { StyledArrowButton } from "../Footer/Footer-styled";

import { Cross, RightArrowIcon } from "../../../Icons";
import { CloseIconContainer, Header } from "../Reports-styled";

const ReportsHeader = ({
  close,
  onArrowClick,
  showArrow,
  isCustom = false,
  title,
  children,
}) => {
  return (
    <Header isCustom={isCustom}>
      {children}
      {showArrow && (
        <StyledArrowButton
          onClick={onArrowClick ? onArrowClick : undefined}
          radius={4}
          disable={!onArrowClick}
        >
          <RightArrowIcon width={12} height={12} />
        </StyledArrowButton>
      )}
      <span style={{ marginLeft: !showArrow ? 16 : 0 }}>{title}</span>
      <CloseIconContainer onClick={close}>
        <Cross />
      </CloseIconContainer>
    </Header>
  );
};

export default ReportsHeader;
